$('document').ready(() => {
    const productFeatureSlider = new Swiper('.product-features-slider__inner', {
        slidesPerView: 1,
        pagination: {
            el: '.product-features-slider__pagination',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                navigation: {
                    nextEl: '.product-features-slider__nav--next',
                    prevEl: '.product-features-slider__nav--prev',
                },
            },
            1024: {
                slidesPerView: 3,
                navigation: {
                    nextEl: '.product-features-slider__nav--next',
                    prevEl: '.product-features-slider__nav--prev',
                },
            }
        }
    });
})
